// extracted by mini-css-extract-plugin
var _1 = "DocFlowSendingEmailContent-modulecontent__JaG1r";
var _2 = "DocFlowSendingEmailContent-modulenoSettings__whUbF DocFlowSendingWidgetContent-moduleDocFlowSendingWidgetContent__dZXYj";
export { _1 as "content", _2 as "noSettings" }
